MW.modules.sharing = {
    buttons: ['pinterest']
};

(function() {
  var sharing = MW.modules.sharing;
  // var shareBar = JST["social_share"]({button: sharing.buttons[0]});
  var $body = $('body');
  var encode = encodeURIComponent;

  var trackingPixel = function(social_messaging, item) {
    ((social_messaging[item] || {}).tracking || []).forEach(function(p) {
      var a = new Image();
      a.src = p;
    });
  };

  var smsSeparator = (function(ua){
    if (ua.indexOf("iPad") > -1 || ua.indexOf("iPhone") > -1) {
      var m = ua.match(/OS (\d+)_/);
      var version = m && parseInt(m[1], 10);
      return (version >= 8) ? "&" : ";";
    } else {
      return "?";
    }
  })(navigator.userAgent); // FOAD, apple

  sharing.shareItem = function(event) {
    var $button = $(event.target),
        type = $button.parent().attr('data-type');
        host = location.protocol + "//" + location.host;

    var set = $button.parentsUntil('body').toArray().reverse();
    var result = set.reduce(function(memo, item){
      var data = $(item).data();
      return Object.keys(data).reduce(function(memo, key){
        if(!!data[key]) {
          memo[key] = data[key];
        }
        return memo;
      }, memo);
    }, {});

    var props = {
      title: result.sharingtitle,
      url: result.sharingurl,
      shareUrl: result.sharingurl,
      mobileUrl: host + result.mobilepath,
      image: result.sharingimage,
      twitterName: result.sharingtweetname,
      twitterText: result.sharingtweettext,
      social_messaging: result.socialmessaging || {}
    };

    MW.events.publish("shared", type);

    switch(type) {
      case "facebook":
        $button.attr('href', "https://facebook.com/share.php?u="+encodeURI(props.url).replace(/#/g, '%23'));
        $button.attr('target', "_blank");
        trackingPixel(props.social_messaging, 'facebook');
      break;
      case "twitter":
        var hashtags = (props.social_messaging.twitter || {}).hashtag || "";
        hashtags = hashtags.replace(/ /g, ",").replace(/#/g, "");
        $button.attr('href', "https://twitter.com/share?text="+props.twitterText+"&url="+props.shareUrl.replace(/#/g, '%23')+(props.twitterName ? "&via="+props.twitterName : "")+"&hashtags="+hashtags);
        $button.attr('target', "_blank");
        trackingPixel(props.social_messaging, 'twitter');
      break;
      case "gplus":
        $button.attr('href', "https://plus.google.com/share?url="+props.url);
        $button.attr('target', "_blank");
      break;
      case "line":
        $button.attr('href', "https://line.me/R/msg/text/?"+props.title+" "+props.shareUrl);
        $button.attr('target', "_blank");
      break;
      case "whatsapp":
        sharing.whatsapp(props.title, props.shareUrl);
        event.preventDefault();
      break;
      case "kakao":
        sharing.openKakao(props.title, props.shareUrl, props.image);
        event.preventDefault();
      break;
      case "pinterest":
        if ($body.hasClass('ios')) {
          $button.attr('href', "hppintrest://?img_src="+btoa(props.image)+"&description="+props.title);
        } else {
          $button.attr('href', "https://pinterest.com/pin/create/button/?url="+props.shareUrl+"&media="+props.image+"&description="+props.title);
          try{parsePinBtns($button);}catch(err){}
        }
        $button.attr('target', "_blank");
      break;
      case "email":
        if ($body.hasClass('desktop')) {
          $button.removeAttr('href');
          var emailShare = new window.MW.modules.EmailShare();
          emailShare.open();
        } else {
          $button.attr('href', "mailto:?subject="+props.title+"&body=Article: "+props.shareUrl);
          $button.attr('target', null);
        }
        trackingPixel(props.social_messaging, 'email');
      break;
      case "sms":
        $button.attr('href', "sms:"+smsSeparator+"body="+encode(props.title+" "+props.mobileUrl));
        $button.attr('target', null);
      break;
      case "tumblr":
        $button.attr('href', "https://www.tumblr.com/share/link?url="+props.shareUrl+"&name="+props.title);
        $button.attr('target', "_blank");
      break;
      case "linkedin":
        $button.attr('href', "https://www.linkedin.com/shareArticle?mini=true&url="+props.shareUrl+"&title="+props.title+"&source=HuffingtonPost");
        $button.attr('target', "_blank");
      break;
      case "comments":
        $button.attr('href', '#comments');
        $button.attr('target', null);
      break;
    }
  };

  sharing.addSocialToImage = function(img) {
    if(img.offsetHeight > 100 || img.naturalHeight > 100 || img.height > 100) {
      var src;
      var wrapperClass;
      var $img = $(img);
      if (!!img.src) {
        src = img.src;
      } else {
        src = img.style.backgroundImage.slice(4, -1);
      }
      var wrapper = $("<span></span>");
      if(img.align == "left" || img.align == "right") {
        wrapper.addClass(img.align);
        img.align = "";
      }
      wrapper.addClass("share-bar-image-wrapper");
      if (!img.src) {
        wrapper.addClass("share-bar-div-wrapper");
      }
      if (!($img.parent().hasClass('listicle__slide-content') || $img.hasClass('top-media__image'))) {
        wrapper.attr("data-beacon", '{"p":{"mnid":"entry_image"}}');
      }
      wrapper.data("sharingimage", src);
      // wrapper.append(shareBar);
      wrapper.insertAfter(img);
      wrapper.prepend(img);
    }
  };

  sharing.addSocial = function(container) {
    var $allAfters;
    var afterSelectors;
    var $container = container || MW.elements.$main;

    // images
    var selectors = ['.js-entry-body>p>img', '.listicle__slide-content>img', '.top-media__image', '.js-entry-body>figure.image>img'];
    var $all = $container.find(selectors.join(', '));

    // insert afters
    // Only a share thing on the headline if the ab test says so
    if (!$body.hasClass('desktop')) {
      afterSelectors = ['.recirc__content-container', '.pane-window__entry-label'];
      $allAfters = $container.find(afterSelectors.join(', '));
    }

    if (!!$allAfters) {
      $allAfters.after(shareBar);
    }

    $all.each(function(ind, img) {
      if (!img.src || img.complete) {
        sharing.addSocialToImage(img);
      }
      else {
        img.addEventListener('load', function(e) {
          sharing.addSocialToImage(e.target);
        });
      }
    });
  };

  if (!$body.hasClass('ios')) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//assets.pinterest.com/js/pinit.js';
    script.setAttribute('defer', true);
    script.setAttribute('async', true);
    script.setAttribute('data-pin-build', 'parsePinBtns');
    document.getElementsByTagName('head')[0].appendChild(script);
  }
}());